import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  type ReferralDetail,
  type UnlinkReason,
} from "../../../domain/entities/referral-backoffice";
import { type ReferralsBackofficeDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const unlinkReferral = createAsyncThunk<
  ReferralDetail,
  { referralId: string; reason: UnlinkReason },
  { dispatch: ReferralsBackofficeDispatch; extra: ExtraArgument; state: State }
>(
  thunkTypes.UNLINK_REFERRAL,
  async ({ referralId, reason }, { extra }) => {
    return await extra.referralsBackofficeRepo.unlink(
      referralId,
      reason,
    );
  },
);
